{
  "version": 1,
  "asset_id": "6dcef594-faa8-4b80-a373-4362dce12fa2",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/6dcef594-faa8-4b80-a373-4362dce12fa2/gebrueder-mayer.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/6dcef594-faa8-4b80-a373-4362dce12fa2/gebrueder-mayer.png",
  "original_filename": "gebrueder-mayer.png",
  "size": 16213,
  "content_type": "image/png",
  "created_at": "2026-06-25T00:53:36Z"
}
